<template>
  <v-container fluid class="px-0 py-0">
    <!--按照培训类别列出各个统计 -->
    <div v-if="loading" class="loading">
      <v-progress-circular indeterminate :size="30" color="primary"></v-progress-circular>
      <br />
      <br />
      统计中，请稍后...
    </div>
    <div v-else>
      <p class="sys-alert" style="font-size: 12px;">
        该数据仅为当前系统数据，未标明业务类型为未标记。
      </p>
      <div class="panel" v-for="(c, cidx) in categories" :key="c.id">
        <h3 class="primary--text">{{ c.l }}</h3>
        <div class="g-info">通过<b>{{ c.pass }}</b>人次 共<b>{{ c.unPass + c.pass }}</b>人次 通过率<b>{{ c.pass ? (c.pass * 100
      / (c.pass + c.unPass)).toFixed(1) : 0 }}</b>%</div>
        <v-layout row wrap>
          <v-flex xm12 sm4 md2 v-for="(vt, idx) in c.vTypes" :key="c.id + vt.id">
            <v-card class="g-detail" :color="vt.show ? colors[idx] : ''
      " :style="{ cursor: c.locs ? 'pointer' : 'auto' }" :dark="vt.show" @click="filterLegend(cidx, idx)">
              <v-card-text>
                {{ vt.l }}
                <p class="g-detail-val">
                  通过<b>{{ vt.pass }}</b>人次 共<b>{{ vt.pass + vt.unPass }}</b>人次 通过率<b>{{ vt.pass ? (vt.pass * 100 /
      (vt.pass + vt.unPass)).toFixed(1) : 0 }}</b>%
                </p>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <div v-if="c.chart">
          <div style="text-align: right;">
            <span style="font-size:12px;cursor: pointer" @click="c.dataView = !c.dataView">{{
      c.dataView ? '图表视图' : '数据视图' }}</span>
          </div>
          <keep-alive>
            <v-data-table :headers="c.tableHeader" :items="c.tableData" v-if="c.dataView" class="elevation-1"
              :rows-per-page-items="[50, 100, { text: '全部', value: -1 }]">
              <template v-slot:items="props">
                <td v-for="header in c.tableHeader" :key="header.text">{{ props.item[header.value] }}</td>
              </template>
            </v-data-table>
            <v-chart v-else :option="c.chart" class="v-chart"
              :style="{ height: c.locs ? '400px' : ((c.chart.yAxis[0].data.length * 90 + 90) + 'px') }" autoresize
              @click="onBarClick($event, cidx)" />
          </keep-alive>
        </div>
        <template v-if="c.orgs">
          <v-divider />
          <div class="table-head">
            企业培训情况一览表（<span class="tip"><b>绝对通过率</b>为参加培训并通过的人数占企业总人数的百分比。</span>）
            <a :href="c.exportUrl" target="_blank">导出Excel表格</a>
          </div>
          <div class="tip"></div>
          <v-data-table :headers="leafTableHeaders" :items="c.orgs"
            :rows-per-page-items="[10, 30, { text: '全部', value: -1 }]" class="elevation-1">
            <template v-slot:items="props">
              <td class="org-td org-name-td">{{ props.item.name }}</td>
              <td class="org-td">{{ props.item.contact }}</td>
              <td class="org-td">{{ props.item.tel }}</td>
              <td class="org-td org-number">{{ props.item.stuCount }}</td>
              <td class="org-td org-number">{{ props.item.joinCount }}</td>
              <td class="org-td org-number">{{ props.item.unJoinCount }}</td>
              <td class="org-td org-number">{{ props.item.joinPer }}</td>
              <td class="org-td org-number">{{ props.item.pass }}</td>
              <!--
                    <td>{{ props.item.unPass }}</td>
                    -->
              <td class="org-td org-number">{{ props.item.passPer }}</td>
              <td class="org-td org-number">{{ props.item.passTotalPer }}</td>
              <td class="org-td-act">
                <a @click="exportUnFinished(props.item)">未完成名单</a>
              </td>
            </template>
          </v-data-table>
        </template>
      </div>
    </div>
  </v-container>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
} from "echarts/components";

import VChart from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  GridComponent,
]);

const barCommons = { type: 'bar', barMaxWidth: 30, barMinWidth: 10, barMinHeight: 10, label: { show: true, position: "right" } },
  barCommonsIS = { ...barCommons, itemStyle: { borderRadius: [0, 10, 10, 0] } };

export default {
  name: "mo-clazz-chart",
  components: {
    "v-chart": VChart,
  },
  props: {
    loc: String,
    month: String,
  },
  data() {
    return {
      loading: true,
      colors: this.$colors,
      leafTableHeaders: [
        { text: "名称", value: "name", class: "org-th org-name-th" },
        { text: "联系人", value: "contact", class: "org-th" },
        { text: "电话", value: "tel", class: "org-th" },
        { text: "总人数", value: "stuCount", class: "org-th" },
        { text: "参训", value: "joinCount", class: "org-th" },
        {
          text: "未参训",
          value: "unJoinCount",
          class: "org-th",
        },
        { text: "参训率(%)", value: "joinPer", class: "org-th", },
        { text: "通过", value: "pass", class: "org-th", },
        /*{ text: "未通过", value: "unPass" },*/
        { text: "通过率(%)", value: "passPer", class: "org-th", },
        {
          text: "绝对通过率(%)",
          value: "passTotalPer",
          class: "org-th",
        },
        { text: "操作", value: "act", sortable: false },
      ],
      categories: [],
      locs: [],
    };
  },
  watch: {
    month() {
      this.load();
    },
  },
  methods: {
    tableHeader(cate) {
      let chart = cate.chart, series = chart.series, headers = [];
      if (cate.orgs) {
        headers.push({ text: "业务类型", value: "vType" });
      } else {
        headers.push({ text: "地区", value: "region" });
      }
      for (let s of series) {
        headers.push({ text: s.name, value: s.name });
      }
      return headers;
    },
    tableData(cate) {
      let chart = cate.chart, categories = cate.orgs ? chart.yAxis[0].data : chart.xAxis[0].data, series = chart.series, data = [], i = 0;
      for (let c of categories) {
        let row = { vType: c };
        if (cate.orgs) {
          row.vType = c;
        } else {
          row.region = c;
        }
        for (let s of series) {
          let d = s.data;
          row[s.name] = d[i];
        }
        data.push(row);
        i++;
      }
      return data;
    },
    hexToRgba(hex, alpha) {
      let r = parseInt(hex.slice(1, 3), 16), g = parent.parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r},${g},${b},${alpha})`;
    },
    exportUnFinished(item) {
      let self = this;
      self.$axios
        .get(
          `/home/my/mo/clazz/actives/${item.cate}?_oid=${item.id}&_month=${self.month}`
        )
        .then((r) => {
          if (
            r.data.status == "ok" &&
            r.data.message &&
            r.data.message.length > 0
          ) {
            let clazzes = r.data.message,
              doExport = (clazzId) => {
                if (!clazzId) {
                  return;
                }
                window.open(
                  `${self.$const.baseUrl}/home/my/mo/clazzstu/export/unfinished.xlsx?_oid=${item.id}&_cid=${clazzId}`
                );
              };
            if (clazzes.length > 1) {
              //让用选择一个培训计划
              self.$dialog.select(
                "选择培训计划",
                {
                  width: 400,
                  items: clazzes,
                  itemLabel: "name",
                  itemVal: "id",
                },
                [
                  {
                    label: "确认",
                    color: "primary",
                    func(id) {
                      doExport(id);
                    },
                  },
                ]
              );
            } else {
              doExport(clazzes[0].id);
            }
            return;
          }
          self.$status("没有未完成名单数据～", "error");
        });
    },
    filterLegend(ci, vi) {
      let self = this, cate = vi !== undefined ? self.categories[ci] : ci;
      if (!cate.locs) {
        return;
      }
      if (vi !== undefined) {
        let vt = cate.vTypes[vi];
        vt.show = !vt.show;
      }
      let obj = {};
      cate.vTypes.forEach((x) => {
        obj[`${x.l}(已完成)`] = x.show;
        obj[`${x.l}(未完成)`] = x.show;
      });
      cate.chart.legend.selected = obj;
    },
    onBarClick(e, idx) {
      let self = this,
        cate = self.categories[idx],
        locs = cate.locs;
      if (locs && locs[e.dataIndex]) {
        self.$emit("loc_click", locs[e.dataIndex]);
      }
    },
    parseByRegion(d) {
      let self = this, regions = d.regions, vehicleTypes = d.vehicleTypes, tmp = d.message, categories = d.categories, data = [];
      let regionHash = { '__': '未标记' }, vTypeHash = { '__': '未标记' }, categoryHash = { '__': '未标记' };

      for (let r of regions) {
        regionHash[r.id] = r.name;
      }
      for (let t of vehicleTypes) {
        vTypeHash[t.value] = t.name;
      }
      for (let c of categories) {
        categoryHash[c.value] = c.name;
      }

      for (let ck in tmp) {
        let cd = tmp[ck], sTypes = {};
        //求业务类型最大范围，用于数据归一化处理
        for (let rk in cd) {
          for (let vk in cd[rk]) {
            sTypes[vk] = { l: vTypeHash[vk], pass: 0, unPass: 0, id: vk };
          }
        }

        let series = [], cate = {
          l: categoryHash[ck],
          id: ck,
          vTypes: [],
          unPass: 0,
          pass: 0,
          chart: {
            title: {
              subtext:
                "地区完成情况分布 ｜ 可点击上方{tip|业务类型方块}显示更多图表信息 ｜ 可点击右上角{tip|数据视图}切换到表格模式查看",
              subtextStyle: {
                rich: {
                  tip: { color: "orange", fontSize: "10px" },
                },
              },
            },
            legend: {
              data: [],
              selected: {},
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            yAxis: [
              {
                type: "value",
              },
            ],
            xAxis: [
              {
                type: "category",
                data: [],
              },
            ],
            series: series
          },
          locs: []
        };


        let i = 0, border = 10;

        for (let vk in sTypes) {
          let color = self.colors[i++], vt = sTypes[vk];
          series.push(
            { name: `${vt.l}(已完成)`, id: vk, stack: vk, data: [], color: color, ...barCommons },
            { name: `${vt.l}(未完成)`, id: vk + '_un_pass', stack: vk, data: [], color: self.hexToRgba(color, 0.5), itemStyle: { borderRadius: [border, border, 0, 0] }, ...barCommons });
        }

        series.push({ name: "总共完成", stack: 'sum', data: [], color: self.colors[i], ...barCommons },
          { name: "总共未完成", stack: 'sum', data: [], color: self.hexToRgba(self.colors[i], 0.5), itemStyle: { borderRadius: [border, border, 0, 0] }, ...barCommons });

        for (let rk in cd) {
          cate.locs.push({ name: regionHash[rk], id: rk });
          cate.chart.xAxis[0].data.push(regionHash[rk]);
          i = 0;
          let tPass = 0, tUnPass = 0, s = null;
          for (let vk in sTypes) {
            s = series[i++];
            let vt = sTypes[vk], vd = cd[rk][vk], pass = vd ? vd.pass : 0, unPass = vd ? vd.unPass : 0;
            vt.pass = vt.pass + pass;
            vt.unPass = vt.unPass + unPass;
            cate.pass = cate.pass + pass;
            cate.unPass = cate.unPass + unPass;
            s.data.push(pass);
            s = series[i++];
            tPass += pass;
            tUnPass += unPass;
            s.data.push(unPass);
          }
          s = series[i++];
          s.data.push(tPass);
          s = series[i++];
          s.data.push(tUnPass);
        }

        for (let vk in sTypes) {
          let vd = sTypes[vk];
          vd.show = false;
          cate.vTypes.push(vd);
        }

        self.filterLegend(cate);
        data.push(cate);
      }
      return data;
    },
    parseByOrg(d) {
      let self = this, vehicleTypes = d.vehicleTypes, tmp = d.message, categories = d.categories, data = [], orgs = d.orgs, acc = self.$store.state.account;
      let vTypeHash = { '__': '未标记' }, categoryHash = { '__': '未标记' };

      for (let t of vehicleTypes) {
        vTypeHash[t.value] = t.name;
      }
      for (let c of categories) {
        categoryHash[c.value] = c.name;
      }

      for (let ck in tmp) {
        let cd = tmp[ck], sTypes = {};
        //求业务类型最大范围，用于数据归一化处理
        for (let ok in cd) {
          for (let vk in cd[ok].vTypes) {
            sTypes[vk] = { l: vTypeHash[vk], pass: 0, unPass: 0, id: vk, show: true };
          }
        }

        let series = [{ name: '完成', data: [], color: 'green', ...barCommonsIS },
        { name: '未完成', data: [], color: 'red', ...barCommonsIS },
        { name: '总计', data: [], color: self.colors[self.colors.length - 1], ...barCommonsIS }],
          cate = {
            l: categoryHash[ck],
            exportUrl: `${self.$const.baseUrl}/home/my/mo/summary/clazz/export/${self.loc || acc.region}/${ck}/${self.month}.xlsx`,
            id: ck,
            vTypes: [],
            unPass: 0,
            pass: 0,
            orgs: [],
            chart: {
              title: {
                subtext: "可点击右上角{tip|数据视图}切换到表格模式查看", subtextStyle: {
                  rich: {
                    tip: { color: "orange", fontSize: "10px" },
                  },
                }
              },
              legend: {
                show: true
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              xAxis: [
                {
                  type: "value",
                },
              ],
              yAxis: [
                {
                  type: "category",
                  data: [],
                },
              ],
              series: series
            }
          };

        let oHash = {};
        for (let ok in cd) {
          let odvd = cd[ok].vTypes, oPass = 0, oUnPass = 0;
          for (let vk in sTypes) {
            let vt = sTypes[vk], vd = odvd[vk], pass = vd ? vd.pass : 0, unPass = vd ? vd.unPass : 0;
            vt.pass = vt.pass + pass;
            vt.unPass = vt.unPass + unPass;
            cate.pass = cate.pass + pass;
            cate.unPass = cate.unPass + unPass;
            oPass += pass;
            oUnPass += unPass;
          }

          oHash[ok] = { pass: oPass, unPass: oUnPass };
        }

        for (let vk in sTypes) {
          let sType = sTypes[vk];
          cate.vTypes.push(sType);
          cate.chart.yAxis[0].data.push(sType.l);
          series[0].data.push(sType.pass);
          series[1].data.push(sType.unPass);
          series[2].data.push(sType.pass + sType.unPass);
        }

        for (let o of orgs) {
          let op = oHash[o.id],
            oPass = op ? op.pass : 0,
            oUnPass = op ? op.unPass : 0;
          cate.orgs.push({
            cate: ck,
            id: o.id,
            name: o.name,
            contact: o.contact || "",
            tel: o.tel || "",
            stuCount: o.estuCount,
            joinCount: Math.min(oPass + oUnPass, o.estuCount),
            unJoinCount:
              o.estuCount - Math.min(oPass + oUnPass, o.estuCount),
            joinPer:
              o.estuCount == 0
                ? 0
                : (
                  (Math.min(oPass + oUnPass, o.estuCount) * 100) /
                  o.estuCount
                ).toFixed(0),
            pass: Math.min(oPass, o.estuCount),
            unPass: Math.min(oUnPass, o.estuCount),
            passPer: Math.min(
              100,
              oPass + oUnPass == 0 ? 0 : (oPass * 100) / (oPass + oUnPass)
            ).toFixed(0),
            passTotalPer: Math.min(
              100,
              o.estuCount == 0 ? 0 : (oPass * 100) / o.estuCount
            ).toFixed(0),
          });
        }
        data.push(cate);
      }
      return data;
    },
    onLoad(d) {
      let self = this, categories = d.orgs ? self.parseByOrg(d) : self.parseByRegion(d);
      self.loading = false;
      for (let c of categories) {
        c.tableHeader = self.tableHeader(c);
        c.tableData = self.tableData(c);
        c.dataView = false;
      }
      self.categories = categories;
    },
    load() {
      let self = this;
      if (!self.month) {
        return;
      }
      let url = `/home/my/mo/summary/clazz/${self.month}`;
      if (self.loc) {
        url = url + "?_loc=" + self.loc;
      }
      self.loading = true;
      self.$axios.get(url).then((r) => {
        self.loading = false;
        if (r.data.status != "ok") {
          return;
        }
        self.onLoad(r.data);
        return;
      });
    },
  },
  created() {
    this.load();
  },
};
</script>
<style scoped>
.panel {
  margin: 8px 0;
  padding: 8px;
  border: solid 1px #eee;
  border-radius: 4px;
}

.panel .g-info {
  color: #8e8e8e;
  padding: 8px 0;
}

.panel .g-info b {
  font-size: 18px;
  color: orange;
  padding: 0 2px;
}

.panel .g-detail {
  margin: 4px;
  margin-right: 8px;
  margin-left: 0;
  min-height: 111px;
}

.panel .g-detail .g-detail-val {
  font-size: 12px;
  margin: 0;
  padding-top: 4px;
}

.panel .v-chart {
  width: 100%;
}

.loading {
  text-align: center;
  padding: 40px;
}

.org-th,
.org-td {
  padding: 0 8px !important;
}

.org-name-th,
.org-name-td {
  white-space: nowrap;
}

.org-td-act {
  white-space: nowrap;
  font-size: 10px;
}

.org-number {
  text-align: right;
}

.table-head {
  margin: 16px 0;
  color: #9c9c9c;
}

.table-head a {
  float: right;
  text-decoration: none;
  font-size: 10px;
}

.table-head .tip {
  color: orange;
  font-size: 10px;
}
</style>